export default "__VITE_ASSET__7fc20192__"